<template lang="html">
  <d-list-group>
    <d-list-group-item
      v-for="(row, index) in list"
      :key="index"
      class="d-flex px-3"
    >
      <span
        class="text-semibold text-fiord-blue col pl-0"
        @click="editItem(row, index)"
      >
        <span class="input-hidden" v-if="row.name" v-html="row.name"></span>
        <span class="no-content" v-else>{{ placeholder }}</span>
      </span>
      <span class="ml-auto text-right text-semibold col-auto px-0">
        <i
          class="fas fa-plus"
          @click="addRow('addHireds')"
          v-if="index + 1 == list.length"
        />
        <i class="fas fa-minus" @click="removeRow(index)"/>
        <i class="fas fa-save" @click="saveItem(index)"/>
      </span>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import SettingsService from '_services/rest/modules/settings';
import { OPTION } from './SettingsModel';
import { _SAVE_EDITOR_TEXT_MODAL_ } from '../../quotation/components/QuotationModel';

export default {
  name: 'item-form-row',
  props: {
    list: {
      type: Array,
    },
    placeholder: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    addRow() {
      return this.list.push({ ...OPTION });
    },
    checkEmptyOptions() {
      if (this.list.length === 0) {
        this.list.push({ ...OPTION });
      }
    },
    editItem(item, index) {
      this.$emit('editItem', { item, type: this.type, index });
    },
    removeRow(index) {
      if (this.list[index].id) {
        SettingsService.removeQuotationContractualItems(this.list[index].id)
          .then(() => {
            this.activeAlert({
              message: 'Item removido com sucesso',
              theme: 'success',
            });
          })
          .catch(error => {
            this.activeAlert({
              message: `${error.message} <br/> ${error.data}`,
              theme: 'danger',
            });
          });
      }
      this.list.splice(index, 1);
      this.checkEmptyOptions();
    },
    saveItem(index) {
      this.$emit('saveItem', { index, type: this.type });
    },
  },
  mounted() {
    Events.$on(_SAVE_EDITOR_TEXT_MODAL_, ({ params }) => {
      if (params.type === this.type) {
        this.saveItem(params.index);
      }
    });
  },
  destroyed() {
    Events.$off(_SAVE_EDITOR_TEXT_MODAL_);
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';

.input-hidden {
  /deep/ p {
    margin-bottom: 0;
  }
}

.fas {
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  &.fa-plus:hover{
    color: $green;
  }
  &.fa-minus:hover{
    color: $red;
  }
  &.fa-save:hover{
    color: $blue;
  }
}
</style>
